var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7d4755b5\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./option.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!happypack/loader?id=babel!../../node_modules/vue-loader/lib/selector?type=script&index=0!./option.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7d4755b5\",\"hasScoped\":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./option.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d4755b5",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/Users/tw93/www/Github/incubator-weex-ui/packages/wxc-grid-select/option.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] option.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d4755b5", Component.options)
  } else {
    hotAPI.reload("data-v-7d4755b5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./packages/wxc-grid-select/option.vue
// module id = 168
// module chunks = 0 1